import { isEmpty as s } from "lodash-es";
import { useMemo as v, useEffect as I } from "react";
import f from "react-fast-compare";
import { usePrevious as E } from "react-use";
import { useWizardContext as h } from "../context/context.js";
function g(d, u) {
  const { formValues: t, formTouched: o, formErrors: r, version: m, dispatch: k } = h(), { setValues: n, errors: a, setErrors: c, touched: p, setTouched: l } = d, e = v(() => u ?? {
    key: "",
    getItem: () => JSON.parse("{}"),
    setItem: () => {
    },
    removeItem: () => {
    },
    loadOnMount: !0
  }, [u]);
  I(() => {
    if (e.key) {
      const y = e.getItem(e.key);
      s(y) || (e.loadOnMount ? k({
        type: "INIT_VALUES",
        values: y
      }) : e.removeItem(e.key));
    }
  }, []);
  const i = E(m);
  I(() => {
    i && !f(i, m) && (s(t) || (n(t), e.key && e.setItem(e.key, t)), !s(r) && !f(r, a) && c(r), !s(o) && !f(o, p) && l(o, !1));
  }, [
    t,
    e,
    i,
    m,
    n,
    l,
    c,
    r,
    a,
    o,
    p
  ]);
}
export {
  g as default
};
